import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Alert, Card, Field, btn, input, msg, primary } from "./common";

const CERT_TONE = { expired: "text-red-800", expiring: "text-amber-800", current: "text-green-800", no_expiry: "text-slate-700" };

function WorkerCard({ w }) {
  return (
    <Card testid={`wf-worker-${w.id}`}>
      <div className="flex flex-wrap justify-between gap-2"><strong>{w.name}</strong><span>{w.trade}</span></div>
      <ul className="mt-1">{w.certifications.map((c) => (
        <li key={c.name} className={CERT_TONE[c.status]} data-testid={`wf-cert-${w.id}-${c.name}`}>{c.name} · {c.expires_on || "no expiry"} · {c.status.replace("_", " ")}</li>))}</ul>
      {"pay_rate_cents" in w && <p data-testid={`wf-pay-${w.id}`}>Pay rate: {w.pay_rate_cents == null ? "not set" : `$${(w.pay_rate_cents / 100).toFixed(2)}/h`}</p>}
      {w.emergency_contact && <p data-testid={`wf-emergency-${w.id}`}>Emergency contact: {w.emergency_contact.name}, {w.emergency_contact.phone}</p>}
    </Card>
  );
}

function AddWorker({ onDone }) {
  const [f, setF] = useState({ name: "", trade: "", cert: "", expires: "" });
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = () => api.post("/workforce/workers", { name: f.name, trade: f.trade, certifications: f.cert ? [{ name: f.cert, expires_on: f.expires || null }] : [] })
    .then(() => { setF({ name: "", trade: "", cert: "", expires: "" }); setErr(""); onDone(); }).catch((e) => setErr(msg(e)));
  return (
    <Card testid="wf-add-worker" className="grid gap-2 sm:grid-cols-5 items-end">
      <Field id="wf-w-name" label="Name"><input id="wf-w-name" className={input} value={f.name} onChange={set("name")} data-testid="wf-w-name" /></Field>
      <Field id="wf-w-trade" label="Trade"><input id="wf-w-trade" className={input} value={f.trade} onChange={set("trade")} data-testid="wf-w-trade" /></Field>
      <Field id="wf-w-cert" label="Certification"><input id="wf-w-cert" className={input} value={f.cert} onChange={set("cert")} data-testid="wf-w-cert" /></Field>
      <Field id="wf-w-exp" label="Expires"><input id="wf-w-exp" type="date" className={input} value={f.expires} onChange={set("expires")} data-testid="wf-w-exp" /></Field>
      <button type="button" className={primary} onClick={save} data-testid="wf-w-save">Add person</button>
      <Alert text={err} testid="wf-w-error" />
    </Card>
  );
}

export default function People({ canAdmin }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/workforce/workers").then((r) => setRows(r.data)).catch((e) => setErr(msg(e, "Could not load people."))), []);
  useEffect(() => { load(); }, [load]);
  return (
    <section className="space-y-3" data-testid="wf-people">
      <h2 className="font-heading text-lg">People</h2>
      <p className="text-xs">Pay rates are shown to finance roles only. Emergency contacts: Founder, Administrators and the person themself.</p>
      {canAdmin && <AddWorker onDone={load} />}
      <Alert text={err} testid="wf-people-error" />
      {rows && rows.length === 0 && <p data-testid="wf-people-empty">No profiles yet.</p>}
      <div className="grid gap-2 md:grid-cols-2">{(rows || []).map((w) => <WorkerCard key={w.id} w={w} />)}</div>
      <button type="button" className={btn} onClick={load} data-testid="wf-people-refresh">Refresh</button>
    </section>
  );
}
